module.exports = function getResource(label) {
    let resources = {
        your: 'Your ',
        colorIQMatch: 'Color iQ match.',
        colorIQ: 'See your Color iQ match'
    };
    return resources[label];
};
